import { PossibleBusinessObject } from '../../types/DatastoreTypes'
import { WeatherData } from '../../util/weather/types'
import { GeoModelCommon } from '../Geo/GeoModelCommon'

const defaultCellLevel = 9
const objectTypeId = 'OpenWeatherData'

interface WeatherDataInstance {
  cached: boolean
  weatherData?: WeatherData
}

export type OpenWeatherDataProps = {
  weatherData: WeatherData
}

export class OpenWeatherData extends GeoModelCommon implements WeatherDataInstance {
  constructor({ ...ob }: PossibleBusinessObject & Partial<OpenWeatherData>) {
    super({ cellLevel: defaultCellLevel, ...ob, type: objectTypeId })
    this.weatherData = ob.weatherData
    this.cached = ob.cached ?? false
  }

  cached: boolean
  weatherData?: WeatherData

  getTimestampMs(): number | undefined {
    return this.weatherData?.timestamp ? this.weatherData?.timestamp * 1000 : undefined
  }
}
